import { Skeleton, TableSkeleton } from '@/_components';
import { CardContainer, SectionHeadingSkeleton } from '@/_containers';

export default function Loading() {
  return (
    <>
      <section className="flex items-center justify-end gap-2">
        <Skeleton className="h-8 w-40 grow-0" />
        <Skeleton className="h-8 w-40 grow-0" />
        <Skeleton className="h-8 w-40 grow-0" />
      </section>
      <CardContainer>
        <SectionHeadingSkeleton withRightSlot />
        <div className="mt-4 flex items-center justify-between">
          <Skeleton className="h-8 w-40 grow-0" />
        </div>
        <div className="mt-4">
          <TableSkeleton numberOfColumns={5} maxRows={2} />
          <div className="mt-4 flex items-center justify-end border-r border-transparent">
            <Skeleton className="h-8 w-40 grow-0" />
          </div>
        </div>
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />
        <div className="mt-4 flex items-center justify-between">
          <Skeleton className="h-8 w-40 grow-0" />
        </div>
        <div className="mt-4">
          <TableSkeleton numberOfColumns={5} maxRows={2} />
          <div className="mt-4 flex items-center justify-end border-r border-transparent">
            <Skeleton className="h-8 w-40 grow-0" />
          </div>
        </div>
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />

        <div className="mt-4 flex items-center justify-between">
          <Skeleton className="h-8 w-40 grow-0" />
        </div>
        <div className="mt-4">
          <TableSkeleton numberOfColumns={5} maxRows={2} />
          <div className="mt-4 flex items-center justify-end border-r border-transparent">
            <Skeleton className="h-8 w-40 grow-0" />
          </div>
        </div>
      </CardContainer>
    </>
  );
}
